import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=2d6d6414&scoped=true&"
import script from "./approveDialog.vue?vue&type=script&lang=js&"
export * from "./approveDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=2d6d6414&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6d6414",
  null
  
)

export default component.exports